import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

class scrollToCta {

	constructor (params) {
		// Init variables
		this.$cache       = {};
		this.$cache.main  = params.target;
		
		gsap.registerPlugin(ScrollToPlugin);

		// Trigger init functions
		this.initCache();
		this.initEventConst();
		this.registerEvents();
	}

	initCache() {
		this.$cache.body = $('body');
		this.$cache.wrap = this.$cache.body.find('.wrap');
		this.$cache.header = this.$cache.body.find('header');
	}

	initEventConst() {
		this.onClickEvent = (e) => this.onClick(e);
	}

	registerEvents() {
		this.$cache.main.on('click', this.onClickEvent);
	}

	onClick(e) {
		e.preventDefault();
		e.stopPropagation();

		let scrollTo = $(e.currentTarget).attr('href');
		
		// let offset = 88;
		// if ((window.bp.value === 'sm' || window.bp.value === 'xs')) offset = 0;
		let offset = 0;
		
		if($(scrollTo).length > 0) {
			gsap.to($(window), {scrollTo: {y: scrollTo, offsetY: offset}, duration: 1.2, ease: "power2.inOut"});
		}
	}
}

export default scrollToCta;


// WEBPACK FOOTER //
// ./scripts/components/scrollto-cta.js